var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.21408 1.33606L7.28102 1.3472L12.9477 2.68053C13.151 2.72836 13.3006 2.89639 13.3285 3.09866L13.3332 3.16724V12.8339C13.3332 13.0427 13.2039 13.2269 13.0134 13.3003L12.9477 13.3206L7.28102 14.6539C6.98959 14.7225 6.70952 14.5221 6.671 14.235L6.6665 14.1672V1.83391C6.6665 1.55754 6.8874 1.34311 7.14816 1.33398L7.21408 1.33606ZM7.6665 2.46521V13.5359L12.3332 12.4379V3.56325L7.6665 2.46521ZM5.99984 2.66724V3.66724H3.6665V12.3339H5.99984V13.3339H3.1665C2.91337 13.3339 2.70418 13.1458 2.67107 12.9018L2.6665 12.8339V3.16724C2.6665 2.91411 2.85461 2.70491 3.09866 2.6718L3.1665 2.66724H5.99984ZM9.33317 7.33391C9.70136 7.33391 9.99984 7.63238 9.99984 8.00057C9.99984 8.36876 9.70136 8.66724 9.33317 8.66724C8.96498 8.66724 8.6665 8.36876 8.6665 8.00057C8.6665 7.63238 8.96498 7.33391 9.33317 7.33391Z",
    fill: "#222729"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon-logout.9ca629991a6b441ed1c7526ad38551e7.svg";
export { ForwardRef as ReactComponent };